// ─── Admin API Endpoints ──────────────────────────────────────────
const ADMIN_BASE = '/admin';

export const ADMIN_ENDPOINTS = {
    MERCHANTS: `${ADMIN_BASE}/merchants`,
    MERCHANT_DETAIL: (merchantId: string) => `${ADMIN_BASE}/merchants/${merchantId}`,
    IMPERSONATE: `${ADMIN_BASE}/impersonate`,
    STOP_IMPERSONATION: `${ADMIN_BASE}/stop-impersonation`,
    AUDIT_LOG: `${ADMIN_BASE}/audit-log`,
    VERIFY_DEVICE: `${ADMIN_BASE}/verify-device`,
    USERS: `${ADMIN_BASE}/users`,
    DEVICES: `${ADMIN_BASE}/devices`,
    DEVICES_PENDING: `${ADMIN_BASE}/devices/pending`,
    MERCHANT_FEATURES: (merchantId: string) => `${ADMIN_BASE}/merchants/${merchantId}/features`,
    MERCHANT_STATUS: (merchantId: string) => `${ADMIN_BASE}/merchants/${merchantId}/status`,
} as const;

// ─── Billing Admin API Endpoints ──────────────────────────────────
// Internal billing lives under the billing router, not the admin one.
const BILLING_ADMIN_BASE = '/billing/admin';

export const BILLING_ADMIN_ENDPOINTS = {
    PLANS: `${BILLING_ADMIN_BASE}/plans`,
    PLAN: (planId: string) => `${BILLING_ADMIN_BASE}/plans/${planId}`,
    PLAN_PRICE: (planId: string) => `${BILLING_ADMIN_BASE}/plans/${planId}/price`,
    PLAN_ARCHIVE: (planId: string) => `${BILLING_ADMIN_BASE}/plans/${planId}/archive`,
    PLANS_REORDER: `${BILLING_ADMIN_BASE}/plans/reorder`,
    LOOKUP: `${BILLING_ADMIN_BASE}/lookup`,
    OVERRIDES: `${BILLING_ADMIN_BASE}/overrides`,
    OVERRIDE: `${BILLING_ADMIN_BASE}/override`,
    COMP: `${BILLING_ADMIN_BASE}/comp`,
} as const;
